/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_App_UniversitiesInputs */

const en_marketing_app_universities = /** @type {(inputs: Marketing_App_UniversitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Harvard, Stanford, and M.I.T.`)
};

const es_marketing_app_universities = /** @type {(inputs: Marketing_App_UniversitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Harvard, Stanford y M.I.T.`)
};

/**
* | output |
* | --- |
* | "Harvard, Stanford, and M.I.T." |
*
* @param {Marketing_App_UniversitiesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const marketing_app_universities = /** @type {((inputs?: Marketing_App_UniversitiesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_App_UniversitiesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_marketing_app_universities(inputs)
	return en_marketing_app_universities(inputs)
});